module.exports = __webpack_public_path__ + "img/popupTitle1.e531b492.png";